import React, { useEffect, useState } from "react";
import {
	TextField,
	Button,
	Box,
	Stack,
	styled,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { updateLocalContact } from "../../../services/clients/ContactsService";
import { showToast } from "../../../components/ui/toaster";
import store from "../../../state/configureStore";
import { fetchContacts, selectedContactAction } from "../../../state/actions/contacts";
import { useDispatch } from "react-redux";
const SaveButton = styled(Button)({
	backgroundColor: "#376AFA",
	fontSize: "16px",
	width: "205px",
	textTransform: "unset",
	height: "53px",
	"&:hover": {
		backgroundColor: "#114ef5",
	},
});

const DeleteButton = styled(Button)({
	backgroundColor: "#F74646",
	fontSize: "16px",
	width: "205px",
	textTransform: "unset",
	height: "53px",
	"&:hover": {
		backgroundColor: "#F74646",
	},
});

const CancelButton = styled(Button)({
	backgroundColor: "#fff",
	fontSize: "16px",
	border: "1px solid #376AFA",
	textTransform: "unset",
	width: "205px",
	height: "53px",
});

const ContactForm = ({
	contactData,
	selectedDomain,
	// selectedContactAction,
	// updateSelectedContact,
	handleCancel,
	handleDelete,
}) => {

	const stylesObj = {
		text: {
			"& .MuiInputLabel-root": {
				fontWeight: "bold",
				fontSize: "1rem",
			},
			"& .MuiOutlinedInput-root": {
				height: "57px",
				borderRadius: "13px",
				"& fieldset": {
					borderColor: "#E7E7FF",
					borderWidth: "2px",
				},
				"&:hover fieldset": {
					borderColor: "#E7E7FF ",
					borderWidth: "2px",
				},
				"&.Mui-focused fieldset": {
					borderColor: "#E7E7FF ",
					borderWidth: "2px",
				},
				"& input ": {
					color: "#727484",
					fontSize: "13px",
					fontWeight: 400,
				},
			},
		},
		add: {
			mr: 1,
			bgcolor: "#B2B4C5",
			color: "white",
			borderRadius: "50%",
			padding: "1px",
			fontSize: "1rem",
		},
		button: {
			fontWeight: 600,
			fontSize: "13px",
			color: "#B2B4C5",
			backgroundColor: "white",
			"&:hover": { backgroundColor: "unset" },
			justifyContent: "flex-start",
		},
	};

	const phoneNumberTypeArr = [
		{ type: "satellite", placeholder: "Satellite", inputPlaceholderCode: "54", inputPlaceholderNumber: "Please enter your Satellite Number", countryCode: "", value: "" },
		{ type: "mobile", placeholder: "Mobile", inputPlaceholderCode: "54", inputPlaceholderNumber: "Please enter your Mobile Number", countryCode: "", value: "" },
		{ type: "land", placeholder: "Landline", inputPlaceholderCode: "54", inputPlaceholderNumber: "Please enter your Landline Number", countryCode: "", value: "" },
	];

	const [phoneType, setPhoneType] = useState([]);
	const [emailType, setEmailType] = useState([{ type: "home", placeholder: "Email home", value: "" }]);
	const [showDeleteButton, setShowDeleteButton] = useState(false);
	const dispatch = useDispatch()

	useEffect(() => {
		if (!contactData) return;

		const prevContactData = contactData.contact ? contactData.contact : contactData;

		const emailAddresses = [];
		let updatedPhoneType = [];
		let updatedEmailType = [];

		if (prevContactData?.phoneNumbers && typeof prevContactData?.phoneNumbers === "object") {
			Object.keys(prevContactData.phoneNumbers).forEach((item) => {
				if (prevContactData.phoneNumbers[item] !== "") {
					let newPhoneType = phoneNumberTypeArr.find((phoneType) => phoneType.type === item);
					if (newPhoneType) {
						newPhoneType = { ...newPhoneType, value: prevContactData.phoneNumbers[item] };
						updatedPhoneType.push(newPhoneType);
					}
				}
			});
		}

		if (prevContactData.emailAddresses && typeof prevContactData.emailAddresses === "object") {
			Object.keys(prevContactData.emailAddresses).forEach((index) => {
				if (prevContactData.emailAddresses[index] !== "") {
					emailAddresses.push(prevContactData.emailAddresses[index]);
				}
			});
		}

		if (emailAddresses.length >= 1) {
			emailAddresses.forEach((email) => {
				if (email !== "") {
					let newEmailType = { ...emailType[0], value: email };
					updatedEmailType.push(newEmailType);
				}
			});
		}

		setPhoneType(updatedPhoneType);
		setEmailType(updatedEmailType);
	}, [contactData]);



	const validatePhone = (number) => {
		const regDelButton = /^(\+?[0-9]+)$/;
		return !regDelButton.test(number);
	};

	const changeNumber = (index, e) => {
		const re = /^[+0-9\b]+$/;
		const value = e.target.value;

		setShowDeleteButton(validatePhone(value));
		if (value === "" || re.test(value)) {
			const newPhones = [...phoneType];
			newPhones[index].value = value;
			setPhoneType(newPhones);
		}
	};

	const changeEmail = (index, e) => {
		const newEmails = [...emailType];
		newEmails[index].value = e.target.value;
		setEmailType(newEmails);
	};

	const clearPhoneNumber = (index) => {
		const updated = [...phoneType];
		updated[index].value = "";
		setPhoneType(updated);
	};

	const clearEmail = (index) => {
		const updated = [...emailType];
		updated[index].value = "";
		setEmailType(updated);
	};

	const removePhone = (index) => {
		const updated = [...phoneType];
		updated.splice(index, 1);
		setPhoneType(updated);
	};

	const removeEmail = (index) => {
		const updated = [...emailType];
		updated.splice(index, 1);
		setEmailType(updated);
	};

	const addPhone = () => {
		const newPhone = phoneNumberTypeArr.find(type => !phoneType.some(phone => phone.type === type.type));
		if (newPhone && phoneType.length < 3) {
			setPhoneType([...phoneType, newPhone]);
		}
	};

	const addEmail = () => {
		if (emailType.length < 2) {
			const newEmail = emailType.length === 1 && emailType[0].type === "home"
				? { type: "work", placeholder: "Email work", value: "" }
				: { type: "home", placeholder: "Email home", value: "" };
			setEmailType([...emailType, newEmail]);
		}
	};

	const updateContact = () => {
		const data = contactData.contact ? contactData.contact : contactData;

		if (!data?.userName || data?.userName === "") return;
		if (phoneType.every((x) => x?.value === "")) {
			return showToast("warning", "Atleast one phone number is required.");
		}

		let saveContactObj = {
			userId: data.userId,
			userName: data.userName,
			emailAddresses: {},
			phoneNumbers: {},
		};

		emailType.forEach((elem, index) => {
			if (elem.value) {
				saveContactObj.emailAddresses[index === 0 ? "home" : "work"] = elem.value;
			}
		});

		phoneType.forEach((elem) => {
			if (elem.value) {
				saveContactObj.phoneNumbers[elem.type] = elem.value;
			}
		});

		updateLocalContact([saveContactObj], selectedDomain.userDomain)
			.then(() => {
				saveContactObj["contactType"] = "local";
				saveContactObj["profilePhoto"] = data.profilePhoto;
				dispatch(selectedContactAction(saveContactObj))
				store.dispatch(fetchContacts({ selectedDomain: selectedDomain.userDomain }, true));
				handleCancel();
			})
			.catch((error) => {
				showToast("error",`Error while updating the contact ${saveContactObj.userName}. Please try again later.`);
				handleCancel();
			});


	};

	const renderPhoneEndAdornment = (elem, index) => (
		<>
			{elem?.value?.length > 0 && (
				<CloseIcon
					onClick={() => clearPhoneNumber(index)}
					sx={{ fontSize: "14px", cursor: "pointer" }}
				/>
			)}
			{index !== 0 && (
				<Box onClick={() => removePhone(index)}>
					<DeleteOutlineIcon sx={{ fontSize: "1.5rem", cursor: "pointer" }} />
				</Box>
			)}
		</>
	);

	const renderEmailEndAdornment = (elem, index) => (
		<>
			{elem?.value?.length > 0 && (
				<CloseIcon
					onClick={() => clearEmail(index)}
					sx={{ fontSize: "14px", cursor: "pointer" }}
				/>
			)}
			{index !== 0 && (
				<Box onClick={() => removeEmail(index)}>
					<DeleteOutlineIcon sx={{ fontSize: "1.5rem", cursor: "pointer" }} />
				</Box>
			)}
		</>
	);

	return (
		<Stack flexDirection="column" alignItems="center" justifyContent="center">
			<Stack flexDirection="column" sx={{ width: "60%", mb: 4 }} justifyContent="center">
				{phoneType.map((elem, index) => (
					<Stack flexDirection="row" alignItems="center" key={index}>
						<TextField
							placeholder={elem.inputPlaceholderNumber}
							type="text"
							sx={{ width: "100%", mb: 2, ...stylesObj.text }}
							value={elem.value}
							onChange={(e) => changeNumber(index, e)}
							InputProps={{
								endAdornment: renderPhoneEndAdornment(elem, index),
							}}
						/>
					</Stack>
				))}
				{phoneType.length < 3 && (
					<Button variant="text" onClick={addPhone} startIcon={<AddIcon sx={stylesObj.add} />} sx={{ mb: 2, ...stylesObj.button }}>
						Add Mobile
					</Button>
				)}

				{emailType.map((elem, index) => (
					<Stack flexDirection="row" alignItems="center" key={index}>
						<TextField
							placeholder={elem.placeholder}
							type="email"
							sx={{ width: "100%", mb: 2, ...stylesObj.text }}
							value={elem.value}
							onChange={(e) => changeEmail(index, e)}
							InputProps={{
								endAdornment: renderEmailEndAdornment(elem, index),
							}}
						/>
					</Stack>
				))}
				{emailType.length < 2 && (
					<Button variant="text" onClick={addEmail} startIcon={<AddIcon sx={stylesObj.add} />} sx={{ mb: 2, ...stylesObj.button }}>
						Add email
					</Button>
				)}
			</Stack>

			<Box sx={{ mb: 8 }}>
				<CancelButton variant="outlined" sx={{ textTransform: "capitalize", mr: "2rem" }} onClick={handleCancel}>
					Cancel
				</CancelButton>
				{showDeleteButton || validatePhone(phoneType[0]?.value) ? (
					<DeleteButton variant="contained" onClick={handleDelete}>
						Delete
					</DeleteButton>
				) : (
					<SaveButton variant="contained" onClick={updateContact}>
						Save
					</SaveButton>
				)}
			</Box>
		</Stack>
	);
};

export default ContactForm;
